export const isTokenExpired = (
  expirationTime: number,
  bufferSeconds: number = 0
): boolean => {
  const currentTime = Math.floor(Date.now() / 1000)
  return currentTime >= expirationTime - bufferSeconds
}
